/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { LoaderFrameStyled } from '../../../../../../../modules/loader/components/styled/LoaderStyled';
import { colors, fonts } from '../../../../../../../theme';
import { FlexColumnStyled } from '../../../../../../common/Block/Flexbox';
import { TextContainerStyled } from '../../../../../../common/TextBlock/styled/TextBlockStyled';
import { tableLoaderShimmer } from '../../../../../styled/TableStyled';

/* Main container */
export const LabelEditorContainerStyled = styled.div.attrs({
    'className': 'label-editor',
    'data-footer-label-editor': 'label-editor',
})`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 600px;
    padding: 24px 0;
    box-sizing: border-box;

    & .label-editor__title, & .label-editor__search, & .label-editor__footer {
        padding: 0 24px;
        box-sizing: border-box;
    }
    & ${LoaderFrameStyled} {
        transform: translate(-50%, -50%);
    }
`;

export const LabelEditorHeaderStyled = styled(FlexColumnStyled).attrs({
    className: 'label-editor__header',
})<{ isLabelsExist: boolean }>`
    margin-bottom: ${props => props.isLabelsExist ? '0' : '24px'};
`;

/* TITLE BLOCK */
export const LabelEditorTitleStyled = styled.div.attrs({
    className: 'label-editor__title',
})`
    display: flex;
    ${fonts.textHeader3};
`;

/* CHECKED ALL */
export const LabelEditorCheckedAllContainer = styled.div.attrs({
    'className': 'label-editor__checked-all',
    'data-label-editor-item': 'label-editor-checked-all',
})`
    display: flex;
    align-items: center;
    height: 44px;
    padding: 10px 32px;
    box-sizing: border-box;
    & ${TextContainerStyled} {
        margin-left: 24px;
    }
`;

/* FOOTER BLOCK */
export const LabelEditorFooterStyled = styled.div.attrs({
    'className': 'label-editor__footer',
    'data-label-editor-footer': 'label-editor-footer',
})`
    display: flex;
    align-items: center;
    margin-top: 24px;
    & .label-editor__footer-link {
        margin-left: 16px;
    }
`;

export interface ILabelEditorSearchStyled {
    isLoading?: boolean;
}

export const LabelEditorSearchStyled = styled.div.attrs((props: { isLoading: boolean }) => ({
    'className': `label-editor__search ${props.isLoading ? 'label-editor__search--loading' : ''}`,
    'data-label-editor-search': 'label-editor-search',
}))<ILabelEditorSearchStyled>`
    display: flex;
    align-items: center;
    margin-top: 24px;
    width: 100%;

    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1;
    padding-top: 16px;
    padding-bottom: 16px;

    > * {
        padding-right: 16px;
        white-space: nowrap;

        &:last-child {
            padding-right: 0;
        }
    }

    &:after {
        display: ${props => props.isLoading ? 'block' : 'none'};
        content: '';

        position: absolute;
        bottom: 0;
        height: 2px;
        width: 100%;
        overflow: hidden;
        backface-visibility: hidden;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
        animation-fill-mode: forwards;
        animation-duration: 2s;
        animation-name: ${tableLoaderShimmer};
        background: ${colors.tableLoaderBackgroundGradient};
        z-index: 4;
    }
`;

export const LabelEditorModalStyled = styled.div`
    max-height: 440px;
    overflow-y: auto;
    padding: 0 24px;
    border-top: 1px solid ${colors.labelEditorItemBorder};
    border-bottom: 1px solid ${colors.labelEditorItemBorder};
`;

export const LabelEditorImportStyled = styled.div`

`;
